export const colorMapper = () => {
  return {
    primary: "var(--chart-non-semantic-bar-1st-segment-rest-background-color)",
    inactive: "var(--chart-non-semantic-bar-1st-segment-inactive-background-color)",
  };
};
